const style = {
  main: {
    sx: {
      pl: 1.5,
      pt: 1.5,
      pb: 1,
      minWidth: '114px',
      '&:not(:first-of-type)': {
        ml: '10px',
      },
    },
  },
  box: {
    display: 'flex',
    alignItems: 'center',
  },
  amount: {
    variant: 'h5',
    sx: {
      pl: '10px',
    },
  },
  title: {
    color: 'textSecondary',
    variant: 'caption',
  },
} as const;

export default style;
